import { useState, useCallback } from 'react';
import { supabase } from '../supabase/client';

interface ValidationState {
  hasPaidPapers: boolean | null;
  isChecking: boolean;
  error: string;
}

export function usePaperValidation() {
  const [validationState, setValidationState] = useState<ValidationState>({
    hasPaidPapers: null,
    isChecking: false,
    error: '',
  });

  const checkPaidPapers = useCallback(async (
    orgName: string,
    categoryName: string,
    levelName: string
  ) => {
    if (!orgName || !categoryName || !levelName) {
      setValidationState({
        hasPaidPapers: null,
        isChecking: false,
        error: '',
      });
      return;
    }

    setValidationState(prev => ({ ...prev, isChecking: true, error: '' }));

    try {
      const { data: papers, error } = await supabase
        .from('papers')
        .select('id')
        .eq('is_published', true)
        .eq('is_free', false)
        .eq('organization', orgName)
        .eq('category_type', categoryName)
        .eq('level_text', levelName)
        .limit(1);

      if (error) {
        setValidationState({
          hasPaidPapers: false,
          isChecking: false,
          error: '校验失败，请稍后重试',
        });
        return;
      }

      const hasPapers = papers && papers.length > 0;
      setValidationState({
        hasPaidPapers: hasPapers,
        isChecking: false,
        error: hasPapers ? '' : '该分类下暂无付费试卷，无法开通套餐',
      });
    } catch (err) {
      setValidationState({
        hasPaidPapers: false,
        isChecking: false,
        error: '校验失败，请稍后重试',
      });
    }
  }, []);

  const resetValidation = useCallback(() => {
    setValidationState({
      hasPaidPapers: null,
      isChecking: false,
      error: '',
    });
  }, []);

  return {
    ...validationState,
    checkPaidPapers,
    resetValidation,
  };
}
